import SupportPage from "../../../../src/mdx/resources/support";
import * as React from 'react';
export default {
  SupportPage,
  React
};